// extracted by mini-css-extract-plugin
export default {"ComplianceAuditStatus":"Style_ComplianceAuditStatus__nxOkh","TableBox":"Style_TableBox__apti0","HeaderText":"Style_HeaderText__d-DuX"};